import DynamicHeader from "components/GlobalComponents/DynamicHeader/DynamicHeader";
import React from "react";
import "./SherbimeFooter.scss";

const SherbimeFooter = () => {
  return (
    <>
      <DynamicHeader title="Sherbime" />
      <div className="sherbime-footer-wrapper">
        <div className="sherbime-container">
          <p>
            Në krye të Administratës së Kuvendit qëndron Sekretari i Përgjithshëm, i cili, në përputhje me dispozitat kushtetuese dhe ligjore, është nëpunësi civil më i lartë i Kuvendit. Sekretari i Përgjithshëm emërohet nga Byroja e Kuvendit, me propozimin e Kryetarit të Kuvendit, në përputhje me legjislacionin për nëpunësin civil.
          </p>
          <p>
            Administrata e Kuvendit organizohet në shërbime, të cilat kryejnë funksione këshillimore, informuese, organizative dhe teknike në mbështetje të veprimtarisë së deputetëve, Kuvendit dhe organeve të tij. Shërbimet e Kuvendit sigurojnë mundësi dhe kushte të barabarta për ushtrimin efektiv të funksioneve kushtetuese dhe ligjore të deputetëve, Kuvendit dhe organeve të tij
          </p>
          <p>Shërbimet e Kuvendit përbëhen nga:</p>
          <p>
            <strong>
              -Zyra e Sekretarit të Përgjithshëm, në përbërje të të cilit janë:
            </strong>{" "}
            : Zv. Sekretar i Përgjithshëm, Sektori i Projekteve, Sektori i Auditit, Sektori i Protokollit dhe të gjithë shërbimet e tjera që kanë varësi nga zyra e Sekretarit të Përgjithshëm.
          </p>
          <p>
            <strong>
              -Shërbimi i Përgjithshëm Legjislativ dhe Monitorimit Institucional, në përbërje të të cilit janë: 
            </strong>{" "}
            Shërbimi i përfaqësimit ligjor në Gjykatë Kushtetuese dhe mbështetjes së Këshillave, Shërbimi i Komisioneve Parlamentare, Shërbimi E-Legis, Shërbimi i Seancës Plenare si dhe Shërbimi i Monitorimit të Institucioneve.
          </p>
          <p>
            <strong>
              -Shërbimi i Përgjithshëm i Komunikimit dhe Dokumentacionit, në përbërje të të cilit janë:
            </strong>{" "}
            Shërbimi i Transparencës, Platformës Televizive dhe Komunikimit, Shërbimi i Dokumentimit të Aktivitetit Parlamentar dhe Sektori i Arkivës Parlamentare.
          </p>
          <p>
            <strong>
              - Shërbimi i Përgjithshëm i Sistemeve të Informacionit dhe Mbrojtja Kibernetike, në përbërje të të cilit janë:
            </strong>{" "}
            Shërbimi i Infrastrukturës dhe Mirëmbajtjta Teknologjike, Shërbimi i Sigurimit të Informacionit dhe Mbrojtja Kibernetike dhe Shërbimi i Aplikacioneve Parlamentare dhe Inovacionit.
          </p>
          <p>
            <strong>
              -Shërbimi i Përgjithshëm i Institutit Parlamentar, në përbërje të të cilit janë:
            </strong>{" "}
            Shërbimi i Edukimit Qytetar, Shërbimi i Kërkimit dhe Analizës, si
            dhe Shërbimi i Botimeve dhe Bibliotekës Parlamentare.
          </p>
          <p>
            <strong>
              -Shërbimi i Përgjithshëm i Integrimit Europian, në përbërje të të
              cilit janë:
            </strong>{" "}
            Shërbimi i Përafrimit të Legjislacionit, Sekretariati i Këshillit
            Kombëtar për Integrimin Europian, si dhe Sekretariati Teknik i Komisionit për Europën dhe Punët e Jashtme.
          </p>
          <p>
            <strong>
              -Shërbimi i Përgjithshëm Administrativ, në përbërje të të cilit
              janë:
            </strong>{" "}
            Shërbimi i Burimeve Njerëzore dhe i Trajtimit të Deputetëve,
            Shërbimi i Financës dhe i Buxhetit, Shërbimi i Mirëmbajtjes dhe Transportit dhe Shërbimi i Prokurimeve.
          </p>
          <p>
            <strong>
              -Shërbimi i Përgjithshëm i Marrëdhënieve me Jashtë, në përbërje të
              të cilit janë:
            </strong>{" "}
            Shërbimi i Bashkëpunimit Dypalësh, Shërbimi i Bashkëpunimit me
            Organizatat Ndërkombëtare, si dhe Shërbimi i Protokollit Zyrtar.
          </p>
          <p>
            Shërbimet e Kuvendit drejtohen dhe përgjigjen për veprimtarinë e tyre përpara Sekretarit të Përgjithshëm të Kuvendit si dhe sipas fushës së përgjegjësisë, përpara Zëvendëssekretarit të Përgjithshëm.
            Struktura e detajuar e Administratës së Kuvendit dhe kufiri organik i punonjësve përcaktohen nga Byroja e Kuvendit, me propozimin e Sekretarit të Përgjithshëm.
          </p>
        </div>
      </div>
    </>
  );
};

export default SherbimeFooter;
